import Field from "@farmact/model/src/model/Field";
import { query, where } from "firebase/firestore";
import { Firebase } from "../../../index";

export function getQueryForFieldsWithIds(fieldIds: Field["id"][]) {
    return query(Firebase.instance().getAllFields(), where("id", "in", fieldIds));
}
